module.exports = __webpack_public_path__ + "static/media/modal-donation.9d5b05ae.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/loyal-design-system/assets/images/banners/modal-donation.png
// module id = 1869
// module chunks = 14